import { Checkbox, styled } from '@mui/material';
import { colours } from 'utils/constants';

export const SeafoamCheckbox = styled(Checkbox)({
  '&.Mui-checked': {
    color: colours.seafoam
  }
});
